import { render, staticRenderFns } from "./lklMoney.vue?vue&type=template&id=0884d98c&scoped=true&"
import script from "./lklMoney.vue?vue&type=script&lang=js&"
export * from "./lklMoney.vue?vue&type=script&lang=js&"
import style0 from "./lklMoney.vue?vue&type=style&index=0&id=0884d98c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884d98c",
  null
  
)

export default component.exports